import getters from '../getters';
import mutations from '../mutations';
import initialState from '../state';

describe('authentication state transitions for required 2FA setup', () => {
  it('treats setup as pending when setupRequired=true (new payload)', () => {
    const state = {
      twoFactorSetup: {
        setupRequired: true,
        required: true,
        completed: false,
      },
    };

    expect(getters.hasPendingTwoFactorSetup(state)).toBe(true);
  });

  it('treats setup as pending when required=true and completed=false (legacy-compatible payload)', () => {
    const state = {
      twoFactorSetup: {
        required: true,
        completed: false,
      },
    };

    expect(getters.hasPendingTwoFactorSetup(state)).toBe(true);
  });

  it('treats setup as not pending when required=true and completed=true', () => {
    const state = {
      twoFactorSetup: {
        required: true,
        completed: true,
        setupRequired: false,
      },
    };

    expect(getters.hasPendingTwoFactorSetup(state)).toBe(false);
  });

  it('applies fallback twoFactorSetup payload when auth_success has no twoFactorSetup', () => {
    const state = JSON.parse(JSON.stringify(initialState));

    mutations.auth_success(state, {
      data: {
        isApiKey: false,
        user: { properties: { tenantIdThemeSetting: null } },
        access: [],
        primaryScopeIds: [],
        primaryTenantIds: [],
        tenantId: 1,
      },
    });

    expect(state.twoFactorSetup).toEqual({
      required: false,
      state: 'completed',
      completed: true,
      setupRequired: false,
    });
  });

  it('clears twoFactorSetup back to completed state on logout', () => {
    const state = JSON.parse(JSON.stringify(initialState));
    state.twoFactorSetup = {
      required: true,
      state: 'verified',
      completed: false,
      setupRequired: true,
    };

    mutations.logout(state);

    expect(state.twoFactorSetup).toEqual({
      required: false,
      state: 'completed',
      completed: true,
      setupRequired: false,
    });
  });
});
